import { AvField } from "availity-reactstrap-validation"
import { Link } from "react-router-dom"
import { Row, Col, Card, CardBody, Alert } from "reactstrap"
import { useEffect, useState } from "react"
import ApplicationService from "services/applications/Application.service"
import ViewAttachments from "components/Application/ViewAttachments"

let appService = null

const DirectorFormAccreditation = props => {
  const BASE_URL = process.env.REACT_APP_BASE_URL
  const [showCertificatePreview, setshowCertificatePreview] = useState(false)
  const certPreviewUrl =
    BASE_URL + "verify/certificate/" + props.appDetails.app_id + "?preview=true"

  const [signedCertificate, setsignedCertificate] = useState(null)
  const [manualProcessing, setmanualProcessing] = useState(false)
  const [staffUploads, setstaffUploads] = useState([])

  useEffect(() => {
    const userObj = JSON.parse(localStorage.getItem("authUser"))
    appService = new ApplicationService(userObj)
    getApplicationAttachments()
  }, [])

  const getApplicationAttachments = () => {
    const descriptions = ["Meeting_Minutes"]
    const atts = props.appDetails.application_attachments.filter(attachment =>
      descriptions.includes(attachment.description)
    )
    setstaffUploads(atts)
  }

  const decisionValueChange = value => {
    // show certificate preview
    if (value == "006") {
      setshowCertificatePreview(true)
    } else {
      setshowCertificatePreview(false)
    }
  }

  const handleDocumentChange = e => {
    if (e.target.files.length > 0) {
      setsignedCertificate(e.target.files[0])
    }
  }

  async function uploadCertificate(e) {
    if (props.appDetails.manually_processed) {
      // e.preventDefault()
      if (signedCertificate == null) {
        e.preventDefault()
        alert("Please select signed certificate!")
        return
      }

      const certificate = {
        file: signedCertificate,
        application_id: props.appDetails.id,
        description: "manual_certificate",
      }

      const response = await appService.uploadSignedManualCertificate(
        certificate
      )

      if (response.status) {
        // setdisableButton(false)
        // setShowSuccessAlert(true)
      } else {
        alert("Error uploading signed certificate. Please try again.")
      }
    }
  }

  return (
    <>
      <Row>
        <Col lg="12">
          <Card>
            <CardBody>
              <div>
                <AvField
                  type="hidden"
                  name="application_id"
                  value={props.appDetails.id}
                />
              </div>

              <div>
                {props.error && props.error == true ? (
                  <Row className="alert alert-danger">
                    <Col md="12">{props.message}</Col>
                  </Row>
                ) : null}

                {props.success && props.success == true ? (
                  <Row className="alert alert-success">
                    <Col md="8">{props.message}</Col>
                    <Col md="4">
                      <Link to="/dashboard" style={{ float: "right" }}>
                        Back
                      </Link>
                    </Col>
                  </Row>
                ) : null}
              </div>

              <div className="mb-3">
                <AvField
                  type="select"
                  name="decision_code"
                  label="Select Decision"
                  onChange={v => {
                    decisionValueChange(v.target.value)
                  }}
                  required
                >
                  <option value="">--select Decision--</option>
                  <option value="006">Approve</option>
                  <option value="008">Send Back</option>
                  <option value="009">Reject</option>
                </AvField>
              </div>

              <Row className="mb-3">
                <label
                  htmlFor="txtAddress1Billing"
                  className="col-lg-3 col-form-label"
                >
                  Reason
                </label>
                <div className="col-lg-9">
                  <AvField
                    type="textarea"
                    name="reason"
                    rows="2"
                    required
                    className="form-control"
                  ></AvField>
                </div>
              </Row>

              {showCertificatePreview ? (
                <Row className="mb-3">
                  <Alert color="info">
                    Before submitting your review, please click on the preview
                    link below to see how the certificate will display after the
                    approval processes.
                  </Alert>
                  <a className="linkItem" target="_blank" href={certPreviewUrl}>
                    Preview Certificate{" "}
                    <i
                      className="fa fa-certificate"
                      title="Preview Certificate"
                    ></i>
                  </a>
                </Row>
              ) : null}

              {props.appDetails.manually_processed ? (
                <>
                  {" "}
                  <Alert color="info">
                    Because this application is marked as archived, you are to
                    upload the signed certificate using the file upload button
                    below.
                  </Alert>
                  <input
                    className="form form-control"
                    type="file"
                    name="final_manual_certificate"
                    accept=".pdf,image/*,.doc,.docx"
                    onChange={handleDocumentChange}
                    required
                  />
                </>
              ) : null}

              <div>
                <hr></hr>
                <label>Documents uploaded by officer</label>
                <ViewAttachments attachments={staffUploads} />
              </div>

              {props.loading && props.loading === true ? (
                <Link
                  to="#"
                  className="spinner-border text-info"
                  style={{ float: "right" }}
                />
              ) : (
                <div className="mt-5">
                  <button
                    className="btn btn-lg btn-primary col-12"
                    disabled={props.success}
                    onClick={uploadCertificate}
                  >
                    Submit Review
                  </button>
                </div>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </>
  )
}

export default DirectorFormAccreditation
